import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onMounted, nextTick } from 'vue';
import { translation } from "../../../lang/Translation";
import { FileManagerPage} from "../types/FileManagerPage"
interface Prop{
  selected : FileManagerPage;
  onChange : (mode:string)=>void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FileManagerPageSwitcher',
  props: {
    selected: null,
    onChange: null
  },
  setup(__props: any) {

const props = __props as {
  selected : FileManagerPage;
  onChange : (mode:string)=>void
};

const t = translation;




onMounted(()=> nextTick(()=>{
  modeChange(props.selected)
}))

const page = ref<FileManagerPage>(props.selected)
const userButtonClass = computed(()=>{
  const isSelected = page.value === 'user';
  return { 'btn-primary' :  isSelected, 'btn-outline-primary' :!isSelected  }
})
const presetButtonClass = computed(()=>{
  const isSelected = page.value === 'preset';
  return { 'btn-primary' :  isSelected, 'btn-outline-primary' :!isSelected  }
})
const eventButtonClass = computed(()=>{
  const isSelected = page.value === 'event';
  return { 'btn-primary' :  isSelected, 'btn-outline-secondary' :!isSelected  }
})

const modeChange = (mode:FileManagerPage) =>{
  page.value = mode;
  props.onChange(mode);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: _normalizeClass(["btn me-2", _unref(userButtonClass)]),
      style: {"min-width":"10rem"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (modeChange('user')))
    }, _toDisplayString(_unref(t).to("マイアセット", "file_page_user")), 3),
    _createElementVNode("button", {
      class: _normalizeClass(["btn mx-2", _unref(presetButtonClass)]),
      style: {"min-width":"10rem"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (modeChange('preset')))
    }, _toDisplayString(_unref(t).to("おすすめアセット", "recommend_asset")), 3),
    _createElementVNode("button", {
      class: _normalizeClass(["btn mx-2", _unref(eventButtonClass)]),
      style: {"min-width":"10rem"},
      onClick: _cache[2] || (_cache[2] = ($event: any) => (modeChange('event')))
    }, _toDisplayString(_unref(t).to("イベント", "file_event")), 3)
  ], 64))
}
}

})